import { createFileRoute } from '@tanstack/react-router'

import { SecuritySettingsPage } from '@/pages/settings/security/SecuritySettingsPage'

export const Route = createFileRoute('/_authenticated/_dashboard/settings/security/')({
  component: SecuritySettingsPage,
})
